<template>
  <v-flex xs12 md6>
    <v-card flat tile>
      <v-card-title class="blue darken-2 white--text">
        <div>
          <span class="title">保護者未登録</span>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <InsertModal @emit="emitting"></InsertModal>
        <SearchModal @emit="emitting"></SearchModal>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import InsertModal from '../modals/insert'
import SearchModal from '../modals/search'
export default {
  name: 'clientAboutGuardiansRegister',
  components: {
    InsertModal,
    SearchModal
  },
  props: [
    'data',
    'status'
  ],
  methods: {
    emitting: function (req) {
      this.$emit('emit', req)
    }
  },
  computed: {
    isRegister () {
      return !!(
        this.$props.data &&
        this.$props.data.id
      )
    }
  }
}
</script>
